module.exports = __webpack_public_path__ + "img/co_za_to.f1100031.jpg";